export default __webpack_public_path__ + "static/media/Robo.000ec465.png";